export class FleetConfiguration {
    fleetId?: string;
    customerId?: string;
    accountId?: string;
    state?: string;
    accessPolicy?: string;
    priority?: number;
    minLaunchCapacity?: number;
}